import { SORTING_DIR } from "@/common/models";
import { ITableConfig } from "@/components/table/table.model";

export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Report Name",
      key: "name",
      spanMin: "20rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
    },
    {
      name: "Parameters",
      key: "params",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    {
      name: "Entity Type",
      key: "entity_type",
      spanMin: "12rem",
      spanMax: "12rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    {
      name: "Created At",
      key: "created_at",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    {
      name: "Generated By",
      key: "generated_by",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    {
      name: "# Entities In List",
      key: "entities_count",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
  ],
};
